import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import ReactModal from 'react-modal';
import successBackground from 'assets/images/success-background.png';

type Props = {
  title: string;
  open: boolean;
  onClose: () => void;
};

const TrafficSuccessModal = (props: Props) => {
  const { open, title, onClose } = props;

  return (
    <ReactModal isOpen={open} onRequestClose={onClose} style={customStyles} ariaHideApp={false}>
      <div className='relative w-[520px] max-w-[90vw] flex flex-col'>
        <img
          src={successBackground}
          alt='Traffic control successful'
          className='w-full object-cover'
        />
        <article className='flex flex-col items-center justify-center text-center pt-[30px] pb-[46px]'>
          <p className='max-w-[300px] text-2xl font-semibold'>{title}</p>
        </article>
        <div className='w-full h-[67px] flex items-center justify-center bg-[#F8F6F7]'>
          <Button small variant='link' color='primary' onClick={onClose}>
            BACK TO MANAGE TRAFFIC
          </Button>
        </div>
        <span
          className='absolute top-5 right-[27px] w-8 h-8 rounded-full cursor-pointer'
          onClick={onClose}
        />
      </div>
    </ReactModal>
  );
};

export default TrafficSuccessModal;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'hidden'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};
